import { Link } from 'react-router';

import useRegion from '~/hooks/useRegion';

import { getMenu } from '.';

type NavItemProps = {
  external?: boolean;
  link: string;
  name: string;
};

const MarketplaceFooter = () => {
  const { code } = useRegion();
  const today = new Date();

  const CopyRightText = () => (
    <>
      <span>{`© ${today.getFullYear()} Sole Supplier® .`}</span>
      <span>{`All rights Reserved®  Company Reg No. 09098756`}</span>
    </>
  );

  const NavItem = ({ link, name, external }: NavItemProps) =>
    external ? (
      <a
        data-testid="footer-nav-link"
        href={link}
        key={name}
        className="marketplace-footer__footerNav--links-item"
      >
        {name}
      </a>
    ) : (
      <Link
        data-testid="footer-nav-link"
        to={link}
        key={name}
        className="marketplace-footer__footerNav--links-item"
      >
        {name}
      </Link>
    );

  return (
    <div className="marketplace-footer" data-testid="marketplace-footer">
      <div className="marketplace-footer__footerNav site-container">
        <div className="marketplace-footer__footerNav--links" role="navigation">
          {getMenu(code).map(({ name, link, external }: NavItemProps) => (
            <NavItem key={name} name={name} link={link} external={external} />
          ))}
        </div>
        <div
          data-testid="footer-copyright"
          className="marketplace-footer__footerNav--copyright"
        >
          <CopyRightText />
        </div>
      </div>
    </div>
  );
};

export default MarketplaceFooter;
